import assign from 'lodash/assign'
import omit from 'lodash/omit'
import React, { FC } from 'react'

export type TBadge = React.HTMLAttributes<HTMLElement> & {
  [key: string]: any
  color?: string
  pill?: boolean // 角丸フラグ
  className?: string
}
const Badge: FC<TBadge> = (props: TBadge) => {
  const badgeProps = assign(omit(props, ['className', 'color', 'pill']))
  const badgeColor = props.color ? props.color : 'primary'
  const badgePill = props.pill ? ' badge-pill' : ''
  const badgeClassName = props.className ? ` ${props.className}` : ''

  return (
    <span className={`badge badge-${badgeColor}${badgePill}${badgeClassName}`} {...badgeProps}>
      {props.children}
    </span>
  )
}

export default Badge
